import React from 'react';
import styled from "styled-components";
import Link from "next/link";
import {UserContext} from "@providers/user";
import {getAvatar, getRealtorProfileUrl} from "@models/user";
import {getAgencyProfileUrl, getLogo} from "@models/agency";
import Icon from "@atoms/icon";
import Avatar from "@atoms/avatar";
import StarRatings from "@atoms/star.ratings";
import {isEmpty} from "@helpers/helpers";
import {formatPhoneNumber} from "@helpers/numbers";
import Stars from "@atoms/stars";
import ConvertPixelToRem from "@helpers/convert.rem";
import StarIcon from '@icons/star.svg';
import PhoneIcon from '@icons/phone.svg';
import VerifiedBadgeIcon from '@icons/verified-badge.svg';

const ContactContent = ({property_id, contactInfo, selectedRate, handleSelectRate}) => {
    const userContext = React.useContext(UserContext);
    let avatarPath = '';
    let profileUrl = '';
    let avatarType = 'user';
    let realtorName = (!isEmpty(contactInfo) && !isEmpty(contactInfo.name)) ? contactInfo.name : 'بدون نام';
    let agencyName = (!isEmpty(contactInfo) && !isEmpty(contactInfo.agency_name)) ? contactInfo.agency_name : 'مالک این ملک';

    if (!isEmpty(contactInfo) && !isEmpty(contactInfo.agency_id) && !isEmpty(contactInfo.agency_name)) {
        avatarPath = getLogo('');
        if (!isEmpty(contactInfo.avatar)) {
            avatarPath = getLogo(contactInfo.agency_id);
        }

        realtorName = '';
        profileUrl = getAgencyProfileUrl(contactInfo);
        avatarType = 'agency';
    } else if (!isEmpty(contactInfo) && !isEmpty(contactInfo.realtor_id) && !isEmpty(contactInfo.realtor_name)) {
        avatarPath = getAvatar('');
        if (!isEmpty(contactInfo.avatar)) {
            avatarPath = getAvatar(contactInfo.realtor_id);
        }

        realtorName = contactInfo.realtor_name;
        profileUrl = getRealtorProfileUrl(contactInfo);
    } else if (!isEmpty(contactInfo) && !isEmpty(contactInfo.id) && !isEmpty(contactInfo.avatar)) {
        avatarPath = getAvatar(contactInfo.id);
    }


    return (
        <div className="h-100">

            {
                (!isEmpty(property_id)) ?
                    <p className="mt-24">
                        موقع تماس بگید که این آگهی رو
                        <br/>
                        با کد <span className="font-weight-bold bg-info px-4 rounded">{property_id}</span> در <span className="font-weight-bold bg-info px-4 rounded">۲نبش</span> پیدا کردید.
                    </p>
                    : ''
            }

            {
                (!isEmpty(contactInfo) && !isEmpty(profileUrl)) ?
                    <a href={profileUrl}>
                        <Avatar src={avatarPath} size="80" className="mt-32" type={avatarType} alt={(!isEmpty(realtorName)) ? realtorName : (!isEmpty(agencyName) ? agencyName : '')} lazyLoad={false}/>
                    </a>
                    :
                    <Avatar src={avatarPath} size="80" className="mt-32" type={avatarType} lazyLoad={false}/>
            }


            <div className="mt-16 text-center">
                {
                    (contactInfo.agency_id) ?
                        <Link href={profileUrl}>
                            <a className="d-flex align-items-center justify-content-center">
                                <span className="d-block h3">{agencyName}</span>
                                {
                                    (!isEmpty(contactInfo) && contactInfo.agency_authenticated) ?
                                        <Icon width={16} height={16} className="mr-8"><VerifiedBadgeIcon/></Icon>
                                        : ''
                                }
                            </a>
                        </Link>
                        :
                        (
                            (!isEmpty(profileUrl) && !isEmpty(contactInfo.realtor_id)) ?
                                <React.Fragment>
                                    <Link href={profileUrl}>
                                        <a className="d-block h3">{realtorName}</a>
                                    </Link>

                                    <div className="d-flex align-items-center justify-content-center">
                                        <span className="d-block" title={agencyName}>
                                            {agencyName}
                                        </span>

                                        {
                                            (!isEmpty(contactInfo) && contactInfo.agency_authenticated) ?
                                                <Icon width={16} height={16} className="mr-8"><VerifiedBadgeIcon/></Icon>
                                                : ''
                                        }
                                    </div>
                                </React.Fragment>
                                :
                                <h4 className="d-block h3">{realtorName}</h4>
                        )
                }

                {
                    (!isEmpty(contactInfo.stars) && !isEmpty(contactInfo.realtor_id) && contactInfo.stars_count > 0) ?
                        <div className="d-flex align-items-center justify-content-center mt-8">
                            <Stars rate={contactInfo.stars}/>
                            <Rate className="mr-8">{contactInfo.stars_count} نفر</Rate>
                        </div>
                        : ''
                }

            </div>

            <div className="mt-16 d-flex flex-column align-items-center">
                {handlePhoneNumbers(contactInfo)}
            </div>

            {
                (contactInfo && isEmpty(contactInfo.agency_id) && !isEmpty(contactInfo.realtor_id) && (!userContext.check || !userContext.isRealtor)) ?
                    <RateToRealtorBox className="mt-40 bg-info rounded-8 w-100 d-flex align-items-center justify-content-center flex-column">
                        <p> چه امتیازی به {realtorName} میدین؟</p>

                        <StarsCard className="mt-8">
                            <StarRatings
                                default_rate={selectedRate}
                                icon={<StarIcon/>}
                                size={22}
                                onChange={(e) => handleSelectRate(e)}
                            />
                        </StarsCard>
                    </RateToRealtorBox>
                    : ''
            }
        </div>
    );
};

export default ContactContent;

export const handlePhoneNumbers = (contact, just_return_numbers = false) => {
    let numbers = [];

    if (!isEmpty(contact.phone1) || !isEmpty(contact.phone2)) {
        if (!isEmpty(contact.phone1)) {
            numbers.push(contact.phone1)
        }

        if (!isEmpty(contact.phone2)) {
            numbers.push(contact.phone2)
        }
    } else if (!isEmpty(contact.agency_phone1) || !isEmpty(contact.agency_phone2)) {
        if (!isEmpty(contact.agency_phone1)) {
            numbers.push(contact.agency_phone1)
        }

        if (!isEmpty(contact.agency_phone2)) {
            numbers.push(contact.agency_phone2)
        }
    } else if (!isEmpty(contact.realtor_phone1) || !isEmpty(contact.realtor_phone2)) {
        if (!isEmpty(contact.realtor_phone1)) {
            numbers.push(contact.realtor_phone1)
        }

        if (!isEmpty(contact.realtor_phone2)) {
            numbers.push(contact.realtor_phone2)
        }
    }

    if (just_return_numbers) {
        return numbers
    }

    if (numbers.length) {
        return (
            numbers.map((number, key) => {
                    let type = 'mobile';
                    if (number.substr(0, 2) !== '09') {
                        type = 'phone';
                    }

                    return (
                        <a href={"tel:" + number} key={key} className="btn btn-sm btn-secondary mt-16 d-inline-flex ">
                            <span>{formatPhoneNumber(number, type)}</span>
                            <Icon width={16} vertical={true} className="mr-8">
                                <PhoneIcon/>
                            </Icon>
                        </a>
                    )
                }
            )
        )
    }
};

// styles

export const StarsCard = styled.div`
  display: inherit;

  i.icons {
    cursor: pointer;
    width: 16px;
    margin-right: 4px;

    &:first-child {
      margin-right: 0;
    }

    svg:hover {
      path {
        fill: ${props => props.theme.secondary};
        stroke: ${props => props.theme.secondary};
      }
    }
  }
`;

const Rate = styled.span`
  font-size: ${ConvertPixelToRem(12)};
  font-weight: normal;
  line-height: 1.58;
  color: ${props => props.theme.black};
`;

const RateToRealtorBox = styled.div`
  padding: 16px 0 20px;
`;